import './person-add.css';
import { supabase } from '../config/supabase.js';
import { showSuccess, showError } from '../utils/toast.js';
import { navigateToList, navigateToPerson } from '../router/router.js';

let allPeople = [];
let selectedParent1 = null;
let selectedParent2 = null;

export function showPersonAdd() {
  document.getElementById('content').classList.add('hidden')
  document.getElementById('person-detail-page').classList.add('hidden')
  document.getElementById('person-edit-page').classList.add('hidden')
  document.getElementById('password-setup-page').classList.add('hidden')
  document.getElementById('user-profile-page').classList.add('hidden')  // ADD THIS
  document.getElementById('person-add-page').classList.remove('hidden')
}

export async function loadPersonAdd() {
  const container = document.getElementById('person-add-page');
  
  // Check if user is admin
  const { data: { user } } = await supabase.auth.getUser();
  if (!user) {
    showError('Please log in to add people');
    navigateToList();
    return;
  }

  const { data: profile } = await supabase
    .from('user_profile')
    .select('role')
    .eq('id', user.id)
    .single();

  if (profile?.role !== 'admin') {
    showError('Only administrators can add people');
    navigateToList();
    return;
  }

  // Load all people for parent search
  await loadAllPeople();

  container.innerHTML = `
    <button id="back-to-list-from-add">← Back to List</button>
    
    <div class="edit-header">
      <h2>Add Person</h2>
      <div class="edit-actions">
        <button type="button" class="btn-secondary" id="cancel-add-btn">Cancel</button>
        <button type="button" class="btn-primary" id="save-new-person-btn">Add Person</button>
      </div>
    </div>

    <form id="person-add-form" class="edit-form">
      <div class="form-section">
        <h3>Basic Information</h3>
        
        <div class="form-row">
          <div class="form-group">
            <label for="first-name">First Name *</label>
            <input type="text" id="first-name" required>
          </div>

          <div class="form-group">
            <label for="last-name">Last Name</label>
            <input type="text" id="last-name">
          </div>
        </div>

        <div class="form-row">
          <div class="form-group">
            <label for="gender">Gender</label>
            <select id="gender">
              <option value="">Unknown</option>
              <option value="M">Male</option>
              <option value="F">Female</option>
              <option value="U">Unknown</option>
            </select>
          </div>
          
          <div class="form-group">
            <label class="checkbox-label">
              <input type="checkbox" id="is-living" checked>
              <span>Person is living</span>
            </label>
          </div>
        </div>
      </div>

      <div class="form-section">
        <h3>Birth Information</h3>
        
        <div class="form-row">
          <div class="form-group">
            <label for="birth-month">Birth Month</label>
            <select id="birth-month">
              <option value="">Unknown</option>
              ${generateMonthOptions('')}
            </select>
          </div>

          <div class="form-group">
            <label for="birth-year">Birth Year</label>
            <input type="number" id="birth-year" min="1700" max="${new Date().getFullYear()}" placeholder="YYYY">
          </div>
        </div>

        <div class="form-group">
          <label for="birth-place">Birth Place</label>
          <input type="text" id="birth-place" placeholder="City, State, Country">
        </div>
      </div>

      <div id="death-section" class="form-section hidden">
        <h3>Death Information</h3>
        
        <div class="form-row">
          <div class="form-group">
            <label for="death-month">Death Month</label>
            <select id="death-month">
              <option value="">Unknown</option>
              ${generateMonthOptions('')}
            </select>
          </div>

          <div class="form-group">
            <label for="death-year">Death Year</label>
            <input type="number" id="death-year" min="1700" max="${new Date().getFullYear()}" placeholder="YYYY">
          </div>
        </div>

        <div class="form-group">
          <label for="death-place">Death Place</label>
          <input type="text" id="death-place" placeholder="City, State, Country">
        </div>
      </div>

      <div class="form-section">
        <h3>Parents</h3>
        
        <div class="form-group">
          <label for="parent1-search">Parent 1</label>
          <div class="typeahead-container">
            <input type="text" id="parent1-search" 
                   placeholder="Start typing to search..." 
                   autocomplete="off">
            <div id="parent1-results" class="typeahead-results"></div>
          </div>
          <div id="parent1-selected" class="selected-person"></div>
        </div>

        <div class="form-group">
          <label for="parent2-search">Parent 2</label>
          <div class="typeahead-container">
            <input type="text" id="parent2-search" 
                   placeholder="Start typing to search..." 
                   autocomplete="off">
            <div id="parent2-results" class="typeahead-results"></div>
          </div>
          <div id="parent2-selected" class="selected-person"></div>
        </div>

        <div class="form-group" id="relation-type-group" style="display: none;">
          <label for="relation-type">Relationship Type</label>
          <select id="relation-type">
            <option value="biological">Biological</option>
            <option value="adopted">Adopted</option>
          </select>
        </div>
      </div>

      <div class="form-section">
        <h3>Notes</h3>
        
        <div class="form-group">
          <textarea id="notes" rows="6" placeholder="Additional notes about this person..."></textarea>
        </div>
      </div>
    </form>
  `;

  setupEventListeners();
}

async function loadAllPeople() {
  const { data, error } = await supabase
    .from('person')
    .select(`
      id,
      person_name (
        given_name,
        surname,
        is_primary
      )
    `)
    .order('id');

  if (error) {
    console.error('Error loading people:', error);
    showError('Error loading people list');
    return;
  }

  // Filter to primary names and format
  allPeople = data
    .map(p => {
      const primaryName = p.person_name?.find(n => n.is_primary);
      if (!primaryName) return null;
      
      return {
        id: p.id,
        name: primaryName.surname 
          ? `${primaryName.given_name} ${primaryName.surname}`.trim()
          : primaryName.given_name
      };
    })
    .filter(p => p !== null);
}

function setupEventListeners() {
  const isLivingCheckbox = document.getElementById('is-living');
  const deathSection = document.getElementById('death-section');
  const parent1Search = document.getElementById('parent1-search');
  const parent2Search = document.getElementById('parent2-search');
  const cancelBtn = document.getElementById('cancel-add-btn');
  const backBtn = document.getElementById('back-to-list-from-add');
  const saveBtn = document.getElementById('save-new-person-btn');

  // Toggle death section
  isLivingCheckbox.addEventListener('change', (e) => {
    if (e.target.checked) {
      deathSection.classList.add('hidden');
    } else {
      deathSection.classList.remove('hidden');
    }
  });

  // Parent search typeahead
  parent1Search.addEventListener('input', (e) => {
    handleParentSearch(e.target.value, 'parent1');
  });

  parent2Search.addEventListener('input', (e) => {
    handleParentSearch(e.target.value, 'parent2');
  });

  // Close typeahead on outside click
  document.addEventListener('click', (e) => {
    if (!e.target.closest('.typeahead-container')) {
      document.getElementById('parent1-results').innerHTML = '';
      document.getElementById('parent2-results').innerHTML = '';
    }
  });

  // Buttons
  cancelBtn.addEventListener('click', () => navigateToList());
  backBtn.addEventListener('click', () => navigateToList());
  saveBtn.addEventListener('click', handleSubmit);
}

function handleParentSearch(query, parentNum) {
  const resultsDiv = document.getElementById(`${parentNum}-results`);
  
  if (!query || query.length < 2) {
    resultsDiv.innerHTML = '';
    return;
  }

  const filtered = allPeople.filter(p => 
    p.name.toLowerCase().includes(query.toLowerCase())
  ).slice(0, 10);

  if (filtered.length === 0) {
    resultsDiv.innerHTML = '<div class="typeahead-item no-results">No results found</div>';
    return;
  }

  resultsDiv.innerHTML = filtered.map(p => `
    <div class="typeahead-item" data-id="${p.id}" data-name="${escapeHtml(p.name)}">
      ${escapeHtml(p.name)}
    </div>
  `).join('');

  resultsDiv.querySelectorAll('.typeahead-item:not(.no-results)').forEach(item => {
    item.addEventListener('click', () => {
      selectParent(parentNum, item.dataset.id, item.dataset.name);
    });
  });
}

function selectParent(parentNum, id, name) {
  if (parentNum === 'parent1') {
    selectedParent1 = { id, name };
    document.getElementById('parent1-search').value = '';
    document.getElementById('parent1-selected').innerHTML = `
      <div class="selected-tag">
        ${escapeHtml(name)}
        <button type="button" class="remove-btn" onclick="window.removeParent1()">×</button>
      </div>
    `;
  } else {
    selectedParent2 = { id, name };
    document.getElementById('parent2-search').value = '';
    document.getElementById('parent2-selected').innerHTML = `
      <div class="selected-tag">
        ${escapeHtml(name)}
        <button type="button" class="remove-btn" onclick="window.removeParent2()">×</button>
      </div>
    `;
  }

  document.getElementById(`${parentNum}-results`).innerHTML = '';
  updateRelationTypeVisibility();
}

window.removeParent1 = () => {
  selectedParent1 = null;
  document.getElementById('parent1-selected').innerHTML = '';
  updateRelationTypeVisibility();
};

window.removeParent2 = () => {
  selectedParent2 = null;
  document.getElementById('person2-selected').innerHTML = '';
  updateRelationTypeVisibility();
};

function updateRelationTypeVisibility() {
  const relationTypeGroup = document.getElementById('relation-type-group');
  if (selectedParent1 || selectedParent2) {
    relationTypeGroup.style.display = 'block';
  } else {
    relationTypeGroup.style.display = 'none';
  }
}

async function handleSubmit(e) {
  e.preventDefault();

  const saveBtn = document.getElementById('save-new-person-btn');
  saveBtn.disabled = true;
  saveBtn.textContent = 'Adding...';

  try {
    // Validate
    const firstName = document.getElementById('first-name').value.trim();
    if (!firstName) {
      showError('First name is required');
      document.getElementById('first-name').classList.add('error');
      saveBtn.disabled = false;
      saveBtn.textContent = 'Add Person';
      return;
    }
    document.getElementById('first-name').classList.remove('error');

    // Check if same parent selected twice
    if (selectedParent1 && selectedParent2 && selectedParent1.id === selectedParent2.id) {
      showError('Cannot select the same person as both parents');
      saveBtn.disabled = false;
      saveBtn.textContent = 'Add Person';
      return;
    }

    // Validate death year >= birth year
    const birthYear = document.getElementById('birth-year').value;
    const deathYear = document.getElementById('death-year').value;
    if (birthYear && deathYear && parseInt(deathYear) < parseInt(birthYear)) {
      showError('Death year cannot be before birth year');
      saveBtn.disabled = false;
      saveBtn.textContent = 'Add Person';
      return;
    }

    // Collect form data
    const formData = {
      firstName: firstName,
      lastName: document.getElementById('last-name').value.trim() || null,
      gender: document.getElementById('gender').value || null,
      isLiving: document.getElementById('is-living').checked,
      birthMonth: document.getElementById('birth-month').value,
      birthYear: document.getElementById('birth-year').value,
      birthPlace: document.getElementById('birth-place').value.trim() || null,
      deathMonth: document.getElementById('death-month').value,
      deathYear: document.getElementById('death-year').value,
      deathPlace: document.getElementById('death-place').value.trim() || null,
      notes: document.getElementById('notes').value.trim() || null,
      relationType: document.getElementById('relation-type').value
    };

    const personId = await createPerson(formData);
    showSuccess('Person added successfully');
    navigateToPerson(personId);
    
  } catch (error) {
    console.error('Error adding person:', error);
    showError(error.message || 'Error adding person');
  } finally {
    saveBtn.disabled = false;
    saveBtn.textContent = 'Add Person';
  }
}

async function createPerson(formData) {
  const { data: { user } } = await supabase.auth.getUser();
  const fullName = formData.lastName ? `${formData.firstName} ${formData.lastName}` : formData.firstName;

  // 1. Insert person record
  const { data: person, error: personError } = await supabase
    .from('person')
    .insert({
      sex: formData.gender,
      is_living: formData.isLiving,
      privacy_level: 'family',
      notes: formData.notes,
      created_by: user.id,
      updated_by: user.id
    })
    .select()
    .single();

  if (personError) throw personError;

  // 2. Insert person_name record
  const { error: nameError } = await supabase
    .from('person_name')
    .insert({
      person_id: person.id,
      name_type: 'birth',
      given_name: formData.firstName,
      surname: formData.lastName,
      full_name: fullName,
      is_primary: true
    });

  if (nameError) throw nameError;

  // 3. Create birth event if birth data provided
  if (formData.birthMonth || formData.birthYear || formData.birthPlace) {
    const dateText = formatDateText(formData.birthMonth, formData.birthYear);
    const dateSort = formatDateSort(formData.birthMonth, formData.birthYear);

    const { error: birthError } = await supabase
      .from('event')
      .insert({
        event_type: 'birth',
        person_id: person.id,
        date_text: dateText,
        date_sort: dateSort,
        place_text: formData.birthPlace,
        privacy_level: 'family',
        show_full_date: false,
        created_by: user.id
      });

    if (birthError) throw birthError;
  }

  // 4. Create death event if deceased and death data provided
  if (!formData.isLiving && (formData.deathMonth || formData.deathYear || formData.deathPlace)) {
    const dateText = formatDateText(formData.deathMonth, formData.deathYear);
    const dateSort = formatDateSort(formData.deathMonth, formData.deathYear);

    const { error: deathError } = await supabase
      .from('event')
      .insert({
        event_type: 'death',
        person_id: person.id,
        date_text: dateText,
        date_sort: dateSort,
        place_text: formData.deathPlace,
        privacy_level: 'family',
        show_full_date: true,
        created_by: user.id
      });

    if (deathError) throw deathError;
  }

  // 5. Create parent relationships if parents selected
  if (selectedParent1 || selectedParent2) {
    await createParentRelationships(person.id, formData.relationType, user.id);
  }

  return person.id;
}

async function createParentRelationships(childId, relationType, userId) {
  let family = null;

  if (selectedParent1 && selectedParent2) {
    // Search for existing family with both parents
    const { data } = await supabase
      .from('family')
      .select('id')
      .or(`and(partner1_id.eq.${selectedParent1.id},partner2_id.eq.${selectedParent2.id}),and(partner1_id.eq.${selectedParent2.id},partner2_id.eq.${selectedParent1.id})`)
      .limit(1)
      .maybeSingle();

    family = data;
  }

  // If no existing family, create one
  if (!family) {
    const { data: newFamily, error: familyError} = await supabase
      .from('family')
      .insert({
        partner1_id: selectedParent1?.id || null,
        partner2_id: selectedParent2?.id || null,
        family_type: 'unknown',
        privacy_level: 'family',
        created_by: userId
      })
      .select()
      .single();

    if (familyError) throw familyError;
    family = newFamily;
  }

  // Link child to family
  const { error: childError } = await supabase
    .from('family_child')
    .insert({
      family_id: family.id,
      child_id: childId,
      relation_type: relationType
    });

  if (childError) throw childError;
}

function formatDateText(month, year) {
  if (!month && !year) return null;
  
  if (month && year) {
    return `01 ${month} ${year}`;
  } else if (year) {
    return year;
  }
  
  return null;
}

function formatDateSort(month, year) {
  if (!year) return null;
  
  const monthNum = month ? getMonthNumber(month) : '01';
  return `${year}-${monthNum}-01`;
}

function generateMonthOptions(selected) {
  const months = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];
  return months.map(month => 
    `<option value="${month}" ${month === selected ? 'selected' : ''}>${month}</option>`
  ).join('');
}

function getMonthNumber(monthAbbr) {
  const months = {
    'JAN': '01', 'FEB': '02', 'MAR': '03', 'APR': '04',
    'MAY': '05', 'JUN': '06', 'JUL': '07', 'AUG': '08',
    'SEP': '09', 'OCT': '10', 'NOV': '11', 'DEC': '12'
  };
  return months[monthAbbr] || '01';
}

function escapeHtml(text) {
  if (!text) return '';
  const div = document.createElement('div');
  div.textContent = text;
  return div.innerHTML;
}
